import { useEffect } from 'react';

import { useCollectContext } from '../../../context/ProviderPage/Coleta';
import { FilterInput } from '../../Inputs/FilterInput';
import { SideMenuFilterTemplete } from '../SideMenuFilterTemplete';

export const FilterOpenedCollect = () => {
  const {
    openSideModalFilterScheduleCollect,
    openSideModalFilterCollectAction,
    cleanAllInputsAction,
    filterCollectAction,
    DFNOMECARRETEIRO,
    setDFNOMECARRETEIRO,
    DFORDEMCOLETA,
    setDFORDEMCOLETA,
    DFNOMELINHA,
    setDFNOMELINHA,
    DFDATASAIDA,
    setDFDATASAIDA,
    DFDATAPROGRAMADA,
    setDFDATAPROGRAMADA,
    DFTOTALARMAZENADO,
    setDFTOTALARMAZENADO,
  } = useCollectContext();

  useEffect(() => {
    if (Number(DFORDEMCOLETA) < 0) {
      setDFORDEMCOLETA('0');
    }
  }, [DFORDEMCOLETA]);

  return (
    <SideMenuFilterTemplete
      isOpen={openSideModalFilterScheduleCollect}
      onchange={openSideModalFilterCollectAction}
      title="Filtrar Aberta"
      cleanAllInputsAction={cleanAllInputsAction}
      filterAction={filterCollectAction}
    >
      <FilterInput
        onChange={setDFORDEMCOLETA}
        value={DFORDEMCOLETA}
        title="Ordem Coleta"
        type="number"
        min={0}
      />
      <FilterInput
        onChange={setDFNOMECARRETEIRO}
        value={DFNOMECARRETEIRO}
        title="Carreteiro"
        type="text"
      />
      <FilterInput
        onChange={setDFTOTALARMAZENADO}
        value={DFTOTALARMAZENADO}
        title="Total em litros"
        type="number"
      />
      <FilterInput
        onChange={setDFNOMELINHA}
        value={DFNOMELINHA}
        title="Linha"
        type="text"
      />
      <FilterInput
        onChange={setDFDATAPROGRAMADA}
        value={DFDATAPROGRAMADA}
        title="Data Programada"
        type="date"
      />
      <FilterInput
        onChange={setDFDATASAIDA}
        value={DFDATASAIDA}
        title="Data Saída"
        type="date"
      />
    </SideMenuFilterTemplete>
  );
};
